import { VIEW_TYPES } from "../constants";

export const SIZES = {
  small: 32,
  medium: 40,
  large: 48,
} as const;

export const COLORS = {
  [VIEW_TYPES.disabled]: "#ECEDEF",
  [VIEW_TYPES.default]: "none",
  [VIEW_TYPES.defaultPositive]: "#FFDA4C",
  [VIEW_TYPES.defaultNegative]: "#E5F1FF",
  [VIEW_TYPES.actionPositive]: "#FFDA4C",
  [VIEW_TYPES.actionNegative]: "#B3D6FF",
  [VIEW_TYPES.clickPositive]: "#FFCF1A",
};

export const STROKE_COLORS = {
  [VIEW_TYPES.disabled]: "none",
  [VIEW_TYPES.default]: "#80BAFF",
  [VIEW_TYPES.defaultPositive]: "none",
  [VIEW_TYPES.defaultNegative]: "none",
  [VIEW_TYPES.actionPositive]: "none",
  [VIEW_TYPES.actionNegative]: "none",
  [VIEW_TYPES.clickPositive]: "none",
};
